import { cn } from '@bem-react/classname';

export const cnKhEmojies = cn('KhEmojies');
